module.exports = __webpack_public_path__ + "img/void.39df76ed.png";